export const COLOR_CONFIG = {
  1: {
    card: 'linear-gradient(to right, var(--color-semantic-white), var(--color-warning20))',
    ribbon: 'var(--color-warning70)',
  },
  2: {
    card: 'linear-gradient(to right, var(--color-semantic-white), var(--color-success20))',
    ribbon: 'var(--color-success70)',
  },
  3: {
    card: 'linear-gradient(to right, var(--color-semantic-white), #F2E6F1)',
    ribbon: '#5C2E90',
  },
  empty: {
    card: 'var(--color-semantic-outline)',
    ribbon: 'var(--color-neutral50)',
  },
  default: {
    card: 'linear-gradient(to right, var(--color-semantic-white), var(--color-primary10))',
    ribbon: 'var(--color-primary40)',
  },
};
